/* tslint:disable:max-line-length */
import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {FirebaseService} from './firebase.service';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {

    constructor(private router: Router, private fireSrv: FirebaseService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // if (this.fireSrv.getLoggedUser() !== null) {
        //     return true;
        // } else {
        //     this.router.navigate(['/login']);
        //     return false;
        // }
        return this.fireSrv.authUser.pipe(
            map(user => {
                if (!user) {
                    this.router.navigate(['/login']);
                    return false;
                }
                return true;
            })
        )
    }

}
